module.exports = __webpack_public_path__ + "static/media/realtimetext-semibold.6109b3b4.woff";